// Custom module for DiscoverLA navigation
(function ($, Drupal, once, drupalSettings) {
  'use strict';

  var DiscoverLA = DiscoverLA || {}; // DLA global object setup

  Drupal.behaviors.dlaItineraryMapbox = {

    // Methods
    attach: function (context, settings) {
      var self = this;

      // $(document).once().each(function () {
      // $(context).find(".node--type-itinerary.node--view-mode-full").once().each(function () {
      $(once('dla-processed', '.node--type-itinerary.node--view-mode-full', context)).ready(function() {

        var isMobile = false; //initiate as false
        // device detection
        if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
          || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))
          || $(window).width() <= 768
        ) {
          isMobile = true;
        }

        // Only apply this for non mobile
        // Open the map on page load to ensure more accurate waypoint calculation
        if (!isMobile) {
          this.mapDisplayed = true; // Track state of map toggle open or not
          // Force slick carousel to resize whenever map is open, which is now defaulted to be open
          if (typeof $.fn.Slick !== 'undefined') {
            clearTimeout(timeout);
            var timeout = setTimeout(function() {
              $slider.slick('slickGoTo', 0);
            }, 300);
          }
        }

        // Setup other nav regions
        self.setupPageWaypoints(context);
        $( window ).resize(function() {
          self.setupPageWaypoints(context);
        });
        // Triggering a window resize here seems to help ensure map renders correctly with all tiles loaded and at appropriate zoom
        $(window).trigger('resize');

      });
    },

    setupPageWaypoints: function (context) {
      var self = this;

      const targetWrapperHeadings = '.page-node-type-itinerary article.node--type-itinerary .paragraph--type--itinerary-item .dla-itinerary-item__title';
      const targetWrapper = '.page-node-type-itinerary article.node--type-itinerary .paragraph--type--itinerary-item';
      const targetWrapperCount = $(targetWrapperHeadings).length;
      const targetChapter = '.page-node-type-itinerary article.node--type-itinerary .chapter';

      // Constantly check to see if entire map object is loaded
      var interval = setInterval(function () {
        if (typeof(Drupal.Leaflet["leaflet-map-view-itinerary-map-block-itinerary-mapbox"].lMap) != 'undefined' && typeof(Drupal.Leaflet["leaflet-map-view-itinerary-map-block-itinerary-mapbox"].markers) != 'undefined') {
          // Ensure mapbox is set to zoom level that fits all markers
          let itineraryMapbox = Drupal.Leaflet["leaflet-map-view-itinerary-map-block-itinerary-mapbox"].lMap;
          let itineraryMapboxMarkers = Drupal.Leaflet["leaflet-map-view-itinerary-map-block-itinerary-mapbox"].markers;
          let bounds = new L.LatLngBounds();
          $.each(itineraryMapboxMarkers, function(index, val) {
            // Extract bound info from all markers
            bounds.extend(itineraryMapboxMarkers[index].getLatLng());
            // Add alt text for all markers - ADA compliance
            if (itineraryMapboxMarkers[index]._icon !== null) {
              itineraryMapboxMarkers[index]._icon.alt = "Image of marker for map that references " + itineraryMapboxMarkers[index].options.title;
            }
          });

          // Set bounds of map to ensure optimal zoom level
          itineraryMapbox.fitBounds(bounds);
          itineraryMapbox.invalidateSize();

          clearInterval(interval);
          // set marker click events
          self.setMarkerEvents(itineraryMapboxMarkers, itineraryMapbox);

          // If we got here, then the map has been loaded so lets remove the map preloader div
          $('.ajax-progress-map').remove();

          if (targetWrapperCount > 0) {
            $(targetWrapper).each(function (itemCounter) {
              // Attach data-position attribute to designate position of itinerary item
              $(this).attr("data-position-global", itemCounter + 1);
              let waypoint = new Waypoint({
                element: this,
                handler: function(direction) {
                  let newHeading = $(this.element).find('.dla-itinerary-item__title').text();
                  let chapter = $(this.element).attr('data-chapter');
                  let section = $(this.element).attr('data-section');
                  self.setNavMessage(newHeading, itemCounter + 1, targetWrapperCount, itineraryMapboxMarkers, itineraryMapbox, chapter, section);
                },
                offset: '50%'
              });
            });
          }

          // If more than one chapter exists, apply highlight markers by chapter feature
          if ($(targetChapter).length > 1) {
            $(window).on('activate.bs.scrollspy', function (e,obj) {
              var activeIndexes = [];
              if ($(obj.relatedTarget).find(".paragraph--type--itinerary-item").length === 0) {
                // If there are no itinerary items in this chapter, it mostly is an overview Chapter
                // so highlight all markers and make all items activeIndexes
                $('[data-position-global]').each(function (index) {
                  activeIndexes.push($(this).attr('data-position-global'));
                });
              } else {
                // Looks like there are some itinerary items in this Chapter, highlight all items in this Chapter
                $(obj.relatedTarget).find(".paragraph--type--itinerary-item").each(function (index) {
                  activeIndexes.push($(this).attr('data-position-global'));
                });
              }
              self.highlightMarkers(itineraryMapboxMarkers, itineraryMapbox, activeIndexes);
            });
          }

        }
      }, 300);

      // Site logo ("reset") and Headline text
      $('.page-node-type-itinerary .dla-hero-content, .page-node-type-article .dla-hero-content').waypoint(function(direction) {
        if (direction == "down") {
          self.setNavHeadline();
        } else if (direction == "up") {
          self.setNavLogo();
        }
      });

    },

    getSiteLogo: function () {
      return '<a title="Home" href="/"><img class="dla-logo" alt="" src="/themes/custom/dla/logo.png"></a>';
    },

    getContentHeadline: function () {
      let contentTitle = $('article.node--type-article h1.dla-headline, article.node--type-itinerary h1.dla-headline').text();
      return contentTitle;
    },

    setNavMessage: function (message, id, total, markers, map, chapter = 0, section = 0) {
      const navMainMessageElement = '.dla-global-message .message';
      let dlaMapID = $('[id^="leaflet-map-view-itinerary-map-block-itinerary-mapbox"]').attr('id');

      if (chapter && section) {
        $(navMainMessageElement).html('<div class="itinerary-nav-title-display">' + message + '</div><div class="itinerary-nav-count-display">' + chapter + ' <span class="seperator"> | </span> ' + section + '</div>');
      } else if (chapter && section === 0) {
        $(navMainMessageElement).html('<div class="itinerary-nav-title-display">' + message + '</div><div class="itinerary-nav-count-display">' + chapter + '</div>');
      } else if (chapter === 0 && section) {
        $(navMainMessageElement).html('<div class="itinerary-nav-title-display">' + message + '</div><div class="itinerary-nav-count-display">' + section + '</div>');
      }

      // Center map on location marker
      let newId = Object.keys(markers)[(id - 1)];

      // Highlight current itinerary item
      $('[data-position-global] .dla-itinerary-item-outline').removeClass("dla-itinerary-item-outline--highlighted");
      $('[data-position-global="' + id + '"] .dla-itinerary-item-outline').addClass("dla-itinerary-item-outline--highlighted");

      map.panTo(markers[newId].getLatLng());
      markers[newId].bindPopup(markers[newId]._popup._content, {offset: L.point(0, -14)}).openPopup();

    },

    setMarkerEvents: function (markers, map) {
      var self = this;

      var isMobile = false; //initiate as false
      // device detection
      if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
        || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))
        || $(window).width() <= 768
      ) {
        isMobile = true;
      }

      $.each(markers, function(index, val) {

        markers[index].on('click', function(e) {

          let newId = Object.keys(markers).indexOf(index) + 1;

          // Set navigation message
          const targetWrapperHeadings = '.page-node-type-itinerary article.node--type-itinerary .paragraph--type--itinerary-item .dla-itinerary-item__title';
          const targetWrapperCount = $(targetWrapperHeadings).length;
          let chapter = $('[data-position-global="' + newId + '"]').attr('data-chapter');
          let section = $('[data-position-global="' + newId + '"]').attr('data-section');
          let newHeading = $('[data-position-global="' + newId + '"]').find('.dla-itinerary-item__title').text();

          self.setNavMessage(newHeading, newId, targetWrapperCount, markers, map, chapter, section);

          Waypoint.disableAll();

          // Set default zoom
          // This will adjust zoom level back to default if current zoom is further away from default (is less than 12)
          // This creates a nice effect allows the map to zoom in on clicked marker if the map is currently zoomed out to far.
          var zoom = 12;
          // If the current zoom level is greater than 12, then do not adjust zoom level and use current zoom as the zoom level during panning
          // This will ensure map does not zoom user out if they happened to click on another marker that is current in view
          if (map.getZoom() >= 12) {
            zoom = map.getZoom();
          }

          // pan and zoom to position of marker when clicked
          map.setView([e.latlng.lat, e.latlng.lng], zoom);

          // Scroll itinerary item into view when corresponding marker is clicked
          var scrollOffset = $(window).height()/2;
          $('html, body').animate({
            scrollTop: $('[data-position-global="' + newId + '"]').offset().top - scrollOffset
          }, 0);

          Waypoint.enableAll();

        });
      });

    },

    highlightMarkers: function (markers, map, activeIndexes) {
      var self = this;
      // Set markers inactive markers to lower opacity
      $.each(markers, function(index, val) {
        //markers[index].setOpacity(0);
        map.removeLayer(markers[index]);
      });
      // Highlight markers that belong to active chapter
      $.each(markers, function(index, val) {
        let newId = Object.keys(markers).indexOf(index) + 1;
        if ($.inArray(newId.toString(), activeIndexes) != -1) {
          // Highlight via opacity
          //markers[index].setOpacity(1);
          map.addLayer(markers[index]);
        }
      });

      // Set bounds of map based on highlighted markers to ensure optimal zoom level
      let bounds = new L.LatLngBounds();
      $.each(markers, function(index, val) {
        // Extract bound info from all markers
        bounds.extend(markers[index].getLatLng());
      });
      map.fitBounds(bounds);
      map.invalidateSize();

    },

    setNavLogo: function () {
      this.logoDisplayed = true;
      $('.dla-navbar .dla-global-message').hide();
      $('.dla-navbar .logo').show();
    },

    setNavHeadline: function () {
      const navMainMessageElement = '.dla-global-message .message';
      let message = this.getContentHeadline();
      $(navMainMessageElement).html(message); // Add content title to center nav message area
      this.logoDisplayed = false;
      $('.dla-navbar .logo').hide();
      $('.dla-navbar .dla-global-message').show();
    },

  };

})(jQuery, Drupal, once, drupalSettings);
